import React, { useEffect, useState, useRef } from "react";

import HttpClient from "../../lib/HttpClient";

import MedicalInvoiceScreen from "../invoice/MedicalInvoiceScreen";
import { useSnackbarContext } from "../../contexts/Snackbar";

// Example usage
export default function MedicalInvoiceContainer({
  appointmentId,
  closeFn,
  invoiceDone,
}: {
  appointmentId: string;
  closeFn: () => void;
  invoiceDone: boolean | undefined | null;
}) {
  const { setSnackbar } = useSnackbarContext();
  const requestGetInvoiceData = (appointmentId: string) =>
    HttpClient.performGet<any>(
      `/api/v1/users/invoice?appointmentId=${appointmentId}`,
    );

  const requestUpdateInvoiceData = (appointmentId: string, data: object) =>
    HttpClient.performPost<any>(`/api/v1/users/invoice`, data);

  const [invoiceData, setInvoiceData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const handleSave = async (data: any): Promise<boolean> => {
    const processedInvoiceData = data;

    try {
      const response = await requestUpdateInvoiceData(
        appointmentId,
        processedInvoiceData,
      );

      if (!response?.body?.status?.success) {
        setSnackbar({
          message:
            response?.body?.status?.message ||
            "Failed to save invoice. Please try again.",
          severity: "error",
        });

        return false;
      }

      setSnackbar({
        message: "Invoice saved successfully!",
        severity: "success",
      });

      return true;
    } catch (err: any) {
      console.error("Failed to update invoice:", err);

      setSnackbar({
        message:
          err?.response?.data?.status?.message ||
          "Something went wrong while saving invoice.",
        severity: "error",
      });

      return false;
    }
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        if (!invoiceDone) {
          const updateResponse = await requestUpdateInvoiceData(appointmentId, {
            appointmentId: appointmentId,
          });
          if (!updateResponse?.body?.status?.success) {
            throw new Error("Failed to update invoice");
          }
        }

        const getResponse = await requestGetInvoiceData(appointmentId);
        if (getResponse?.body?.status?.success) {
          setInvoiceData(getResponse.body?.invoice);
        }
      } catch (err) {
        console.error("Failed to fetch invoice:", err);
      } finally {
        setLoading(false);
      }
    };

    if (appointmentId) {
      fetchInvoice();
    }
  }, [appointmentId, invoiceDone]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!invoiceData) {
    return (
      <div className="text-danger text-center ">No invoice data found.</div>
    );
  }

  return (
    <MedicalInvoiceScreen
      invoice={invoiceData}
      onSave={handleSave}
      onCancel={closeFn}
      invoiceDone={invoiceDone}
    />
  );
}
